import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppLayout from "./components/Layout/AppLayout";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

import Dashboard from "./pages/Dashboard";
import Categorias from "./pages/productos/Categorias";
import Productos from "./pages/productos/Productos";
import Pedidos from "./pages/Pedidos";
import Configuracion from "./pages/configuracion/Configuracion";
import Usuarios from "./pages/seguridad/Usuarios";
import Roles from "./pages/seguridad/Roles";
import Suscripcion from "./pages/Suscripcion";
import HistorialPagos from "./pages/pagos/HistorialPagos";
import Clientes from "./pages/clientes/Clientes";
import MenuPublico from "./pages/MenuPublico";

function PrivateRoute({ children }) {
  const { usuario, loading } = useAuth();
  if (loading)
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  return usuario ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  return usuario ? <Navigate to="/dashboard" replace /> : children;
}


export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/registro" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/olvide-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/restablecer-password" element={<ResetPassword />} />
          <Route path="/catalogo/:subdominio" element={<MenuPublico />} />

          <Route path="/" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="categorias" element={<Categorias />} />
            <Route path="productos" element={<Productos />} />
            <Route path="pedidos" element={<Pedidos />} />
            <Route path="configuracion" element={<Configuracion />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="roles" element={<Roles />} />
            <Route path="suscripcion" element={<Suscripcion />} />
            <Route path="historial-pagos" element={<HistorialPagos />} />
            <Route path="clientes" element={<Clientes />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
